import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';

import { BranchesService } from '../../services/branches.service';
import { NewEquipmentService } from '../../services/new-equipment.service';
import { LegalService } from '../../services/legal.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, NgOptimizedImage],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BranchesService, LegalService],
})
export class Footer {
  private readonly branchesService = inject(BranchesService);
  private readonly newEquipmentService = inject(NewEquipmentService);
  private readonly legalService = inject(LegalService);

  /** 🔑 Constantes */
  readonly currentYear = new Date().getFullYear();

  /** 🔑 Estado visual */
  readonly isMobileView = signal(false);
  readonly linksPanelVisible = signal(false);

  readonly panelMovil = signal<Record<string, boolean>>({
    equipments: false,
    branches: false,
    customers: false,
    suppliers: false,
  });

  /** 🔑 Datos async */
  private readonly locationsData = toSignal(this.branchesService.getBranches());
  readonly locations = computed(() => this.locationsData()?.results ?? []);

  readonly newEquipments = toSignal(this.newEquipmentService.getCategories(0, 0, ''), {
    initialValue: {
      count: 0,
      next: '',
      previous: '',
      results: [],
    },
  });

  readonly legalsResponse = toSignal(this.legalService.getLegals(), {
    initialValue: { results: [], count: 0, next: '', previous: '' },
  });

  readonly legals = computed(() => this.legalsResponse().results);

  constructor() {
    this.detectScreenSize();
  }

  toggleLinksPanel(): void {
    this.linksPanelVisible.update((v) => !v);
  }

  togglePanel(panel: string): void {
    if (!this.isMobileView()) return;

    this.panelMovil.update((state) => {
      const updated = Object.keys(state).reduce(
        (acc, key) => ({ ...acc, [key]: key === panel ? !state[key] : false }),
        {} as Record<string, boolean>,
      );
      return updated;
    });
  }

  private detectScreenSize(): void {
    if (typeof window === 'undefined') return;

    const isMobile = window.innerWidth <= 992;
    this.isMobileView.set(isMobile);

    if (!isMobile) {
      this.panelMovil.set({
        equipments: true,
        branches: true,
        customers: true,
        suppliers: true,
      });
    }
  }

}
